// Theme Context — gerencia tema claro/escuro do Cockpit Marçal.
// Sprint 3 do plano operacional (2026-05-24).
//
// AZUL PLANTO (2026-07-11, decisão do Thiago): tema ÚNICO — o skin glass
// escuro É o visual do cockpit, sem toggle e sem opt-out. O contexto fica
// pela compatibilidade (vários componentes chamam useTheme), mas tema é
// sempre 'dark'; setTema/toggle viraram no-ops. O CSS do tema claro
// ([data-theme="light"] no global.css) fica dormante — reativar = voltar
// este arquivo pro git history.

import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const tema = 'dark';

  // Cockpit (escritório) = tema escuro (skin glass). App do cliente (/cliente)
  // = tema CLARO (a régua do Meu Contador é clara). Sem isso, as telas do
  // cliente que usam var(--sa-*) herdavam o escuro e ficavam pretas (relato do
  // Bruno: "tela de notas escura"). A troca fina por rota fica no App (AplicarTema).
  useEffect(() => {
    const caminho = typeof window !== 'undefined' ? window.location.pathname : '';
    const ehCliente = caminho.startsWith('/cliente') || caminho.startsWith('/w/'); // /w/ = app e painel da marca
    document.documentElement.setAttribute('data-theme', ehCliente ? 'light' : 'dark');
  }, []);

  const setTema = () => {};
  const toggle = () => {};

  return (
    <ThemeContext.Provider value={{ tema, setTema, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    // Fallback gracioso pra componentes que renderizam fora do provider
    return { tema: 'dark', setTema: () => {}, toggle: () => {} };
  }
  return ctx;
}
